import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';

const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage'));
const TorrentsPage = lazy(() => import('@/features/torrents/TorrentsPage'));
const TorrentDetailPage = lazy(() => import('@/features/torrents/TorrentDetailPage'));
const DownloadsPage = lazy(() => import('@/features/downloads/DownloadsPage'));
const CompletedPage = lazy(() => import('@/features/completed/CompletedPage'));
const StoragePage = lazy(() => import('@/features/storage/StoragePage'));
const ActivityPage = lazy(() => import('@/features/activity/ActivityPage'));
const HealthPage = lazy(() => import('@/features/health/HealthPage'));
const SettingsPage = lazy(() => import('@/features/settings/SettingsPage'));
const NotFoundPage = lazy(() => import('./NotFoundPage'));

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/torrents" element={<TorrentsPage />} />
        <Route path="/torrents/:id" element={<TorrentDetailPage />} />
        <Route path="/downloads" element={<DownloadsPage />} />
        <Route path="/completed" element={<CompletedPage />} />
        <Route path="/storage" element={<StoragePage />} />
        <Route path="/activity" element={<ActivityPage />} />
        <Route path="/system-health" element={<HealthPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
